// frontend/src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import {
  AcademicCapIcon,
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  ArrowUpIcon,
} from "@heroicons/react/24/outline";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <AcademicCapIcon className="h-8 w-8 text-amber-400" />
              <span className="text-xl font-bold">SSKRU Lifelong</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              มหาวิทยาลัยราชภัฏศรีสะเกษ มุ่งมั่นพัฒนาระบบการเรียนรู้ตลอดชีวิต
              เพื่อยกระดับคุณภาพชีวิตและความก้าวหน้าทางอาชีพของประชาชนทุกคน
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">เมนู</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-amber-400 transition"
                >
                  หน้าหลัก
                </Link>
              </li>
              <li>
                <Link
                  to="/courses"
                  className="text-gray-400 hover:text-amber-400 transition"
                >
                  หลักสูตรทั้งหมด
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-amber-400 transition"
                >
                  ถาม/ตอบ
                </Link>
              </li>
              <li></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">ติดต่อ</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start space-x-3">
                <MapPinIcon className="h-5 w-5 text-amber-400 flex-shrink-0" />
                <span className="text-sm">
                  319 ถ.ไทยพันทา ต.โพธิ์ อ.เมือง จ.ศรีสะเกษ 33000
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 text-amber-400" />
                <span className="text-sm">
                  {" "}
                  <a href="tel:045-564-362-2">045-564-362-2</a>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-amber-400" />
                <span className="text-sm">
                  {" "}
                  <a href="mailto:lifelong@sskru.ac.th">lifelong@sskru.ac.th</a>
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4">ติดตามเรา</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/APLM2024?locale=th_TH"
                target="_blank"
                className="bg-gray-800 p-2 rounded-full hover:bg-amber-600 transition"
              >
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@SSKRU-knowledge"
                target="_blank"
                className="bg-gray-800 p-2 rounded-full hover:bg-amber-600 transition"
              >
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>
            &copy; {new Date().getFullYear()} มหาวิทยาลัยราชภัฏศรีสะเกษ.
            สงวนลิขสิทธิ์.
          </p>
        </div>
      </div>

      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 bg-amber-500 hover:bg-amber-600 text-white p-3 rounded-full shadow-lg transition duration-300"
      >
        <ArrowUpIcon className="h-6 w-6" />
      </button>
    </footer>
  );
}
